import styled from "styled-components";

const PreviewDisclaimer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.primary2};
  color: ${({ theme }) => theme.colors.primary2};
  padding: 12px 16px;
  display: flex;
  gap: 8px;

  img {
    height: 24px;
    width: 24px;
  }
`;

export default PreviewDisclaimer;
